import {Action} from '@ngrx/store';
import {type} from '../utils/type';
import {CATEGORY} from '../common/category.common';

export interface IStatesActions {
    LOAD_STATES: string;
    LOAD_STATES_SUCCESS: string
    LOAD_STATES_FAILURE: string
}

export const ActionTypes: IStatesActions = {
    LOAD_STATES: type(`${CATEGORY} Load States`),
    LOAD_STATES_SUCCESS: type(`${CATEGORY} Load States Success`),
    LOAD_STATES_FAILURE: type(`${CATEGORY} Load States Failure`)
};

export class LoadStatesAction implements Action {
    type = ActionTypes.LOAD_STATES;
    payload: string = null;
}

export class LoadStatesSuccessAction implements Action {
    type = ActionTypes.LOAD_STATES_SUCCESS;
    constructor(public payload: any[]) {
    }
}

export class LoadStatesFailureAction implements Action {
    type = ActionTypes.LOAD_STATES_FAILURE;
    payload: string = null;
}

export type Actions
    = LoadStatesAction
    | LoadStatesSuccessAction
    | LoadStatesFailureAction
